import { Component } from '@angular/core';

@Component({
  selector: 'app-unit-details-header-title',
  templateUrl: './unit-details-header-title.component.html',
  styleUrls: ['./unit-details-header-title.component.scss']
})
export class UnitDetailsHeaderTitleComponent {

}
